import { render } from "./selectTienda.vue?vue&type=template&id=cc052e16"
import script from "./selectTienda.vue?vue&type=script&lang=ts"
export * from "./selectTienda.vue?vue&type=script&lang=ts"
script.render = render

export default script